import React from "react"
import { useCurrentEditor, useCurrentNode } from "@convertkit/editor"
import { BasicSetting as BasicSettings } from "./nodes/basic"
import { ButtonSetting as ButtonSettings } from "./nodes/button"
import { HeadingSettings } from "./nodes/heading"
import { ImageMenu as ImageSettings } from "./nodes/image"
import { TimerMenu as TimerSettings } from "./nodes/timer"
import { VideoSettings } from "./nodes/video"
import { ListSettings } from "./nodes/list"
import { ParagraphSettings } from "./nodes/paragraph"
import { BlockquoteSettings } from "./nodes/blockquote"
import { NoSettings } from "./nodes/utils/no-settings"
import { useParentSection } from "../section/utils/use-parent-section"

const SETTINGS_COMPONENTS = {
  button: ButtonSettings,
  image: ImageSettings,
  spotify: BasicSettings,
  timer: TimerSettings,
  video: VideoSettings,
  section: {
    button: ButtonSettings,
    image: ImageSettings,
    paragraph: ParagraphSettings,
    spotify: BasicSettings,
    timer: TimerSettings,
    video: VideoSettings,
    "blockquote-line": BlockquoteSettings,
    "list-item-child": ListSettings,
    "heading-one": HeadingSettings,
    "heading-two": HeadingSettings,
    "heading-three": HeadingSettings,
    "heading-four": HeadingSettings,
    "heading-five": HeadingSettings,
    "heading-six": HeadingSettings
  }
}

const Container = ({ children, className = "" }) => (
  <div className={"px-4 pb-4 text-gray-700 ".concat(className)}>{children}</div>
)

export function TextSettings({ block_id }) {
  const editor = useCurrentEditor()
  const focusedNode = useCurrentNode() || {}
  const section = useParentSection(block_id)
  const SettingsComponent = section
    ? SETTINGS_COMPONENTS["section"][focusedNode.type]
    : SETTINGS_COMPONENTS[focusedNode.type]

  if (!section && !SettingsComponent) {
    return null
  }

  if (!SettingsComponent) {
    return (
      <Container>
        <NoSettings />
      </Container>
    )
  }

  return (
    <Container>
      <SettingsComponent
        key={focusedNode.key || block_id}
        block_id={block_id}
        editor={editor}
        node={focusedNode}
      />
    </Container>
  )
}
